module.exports = __webpack_public_path__ + "img/2.3fc98f81.svg";